import { AllGeoJSON } from "@turf/helpers";
import { bbox } from "@turf/turf";
import { LatLng, LatLngBoundsExpression } from "leaflet";
import { useEffect } from "react";
import { Marker, Popup, Tooltip, useMap } from "react-leaflet";
import { IMarker } from "./app";
import { Card } from "./card";
import { MarkerIcon } from "./markerIcon";

interface IMarkerProps {
  markers: IMarker[];
  hidePopup?: boolean;
}
export function Markers({ markers, hidePopup = false }: IMarkerProps) {
  const map = useMap();

  useEffect(() => {
    if (markers.length > 0) {
      const geo: AllGeoJSON = {
        type: "GeometryCollection",
        geometries: markers.map((marker) => ({
          type: "Point",
          coordinates: [marker.coordinates[1], marker.coordinates[0]],
        })),
      };

      const bounds = bbox(geo);
      const isInvalidBounds = bounds.some((i: any) => isNaN(i) || !Number.isFinite(i));
      if (isInvalidBounds) {
        console.error("Invalid bounds:", bounds);
        return;
      }

      const boundExpression: LatLngBoundsExpression = [
        [bounds[1], bounds[0]],
        [bounds[3], bounds[2]],
      ];

      map.flyToBounds(boundExpression, { duration: 0.5, animate: false });
    }
  }, [markers, map]);

  return markers.map((item: IMarker) => (
    <Marker
      key={item.id}
      icon={MarkerIcon()}
      position={new LatLng(item.coordinates[0], item.coordinates[1])}
    >
      <Tooltip direction="auto">
        <strong>{item.title}</strong>
      </Tooltip>
      {!hidePopup && (
        <Popup>
          <Card item={item} />
        </Popup>
      )}
    </Marker>
  ));
}
